module.exports = __webpack_public_path__ + "img/wap_phone@2x.1a2f8b94.png";